import { TabButtons } from "@/components/shared/TabButtons";
import s from "./WordToPagesInput.module.scss";
import { InputNumberRange } from "@/components/UI/form/InputNumberRange";
import { useState } from "react";
import { UnitField } from "@/content/samples/types";

type WordsPagesInputProps = {
  initialField?: UnitField;
  onTabChange?: (value: UnitField) => void;
  initialWordsValue?: {
    from?: string;
    to?: string;
  };
  initialPagesValue?: {
    from?: string;
    to?: string;
  };

  onWordsChange?: () => void;
  onPagesChange?: () => void;
};

const MIN_PAGES = 1;
const MAX_PAGES = 100;
const MIN_WORDS = 100;
const MAX_WORDS = 60000;
export const WordsPagesInput = ({
  initialField = "pages",
  onTabChange,
  onWordsChange,
  onPagesChange,
  initialWordsValue,
  initialPagesValue,
}: WordsPagesInputProps) => {
  const [unitField, setUnitField] = useState<UnitField>(initialField);

  const handleWordsPagesTabChange = (value: UnitField) => {
    setUnitField(value);
    onTabChange?.(value);
  };

  return (
    <>
      <TabButtons
        items={[
          {
            tabKey: "pages",
            button: "Pages",
          },
          {
            tabKey: "words",
            button: "Words",
          },
        ]}
        size="small"
        className={s.unitTabs}
        activeKey={unitField}
        onChange={handleWordsPagesTabChange}
        breakpoint="none"
      />
      {unitField === "words" ? (
        <InputNumberRange
          min={MIN_WORDS}
          max={MAX_WORDS}
          name="words"
          initialValue={initialWordsValue}
          onChange={onWordsChange}
        />
      ) : (
        <InputNumberRange
          min={MIN_PAGES}
          max={MAX_PAGES}
          name="pages"
          initialValue={initialPagesValue}
          onChange={onPagesChange}
        />
      )}
    </>
  );
};
